import React, { useState, useEffect, useRef, useCallback } from 'react';

const PHRASES = [
  'Cinematic color, simplified',
  'Pro color, made easy',
  'Film-grade color, no hassle',
  'Cinematic looks, zero complexity',
  'Effortless cinematic color',
];

const randSpeed = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

const ShopHero = () => {
  const [display, setDisplay] = useState('');
  const [cursorVisible, setCursorVisible] = useState(true);
  const phraseIdx = useRef(0);
  const timeoutRef = useRef(null);

  // Cursor blink
  useEffect(() => {
    const id = setInterval(() => setCursorVisible((v) => !v), 530);
    return () => clearInterval(id);
  }, []);

  const typePhrase = useCallback(() => {
    const phrase = PHRASES[phraseIdx.current % PHRASES.length];
    // Random speeds per phrase
    const typeSpeed = { min: randSpeed(60, 100), max: randSpeed(120, 180) };
    const deleteSpeed = { min: randSpeed(35, 55), max: randSpeed(65, 100) };
    const pauseAfterType = randSpeed(3500, 5500);
    const pauseAfterDelete = randSpeed(600, 1200);

    let i = 0;

    const typeChar = () => {
      if (i <= phrase.length) {
        setDisplay(phrase.slice(0, i));
        i++;
        timeoutRef.current = setTimeout(typeChar, randSpeed(typeSpeed.min, typeSpeed.max));
      } else {
        // Pause then delete
        timeoutRef.current = setTimeout(deleteChar, pauseAfterType);
      }
    };

    const deleteChar = () => {
      if (i > 0) {
        i--;
        setDisplay(phrase.slice(0, i));
        timeoutRef.current = setTimeout(deleteChar, randSpeed(deleteSpeed.min, deleteSpeed.max));
      } else {
        // Move to next phrase
        phraseIdx.current++;
        timeoutRef.current = setTimeout(typePhrase, pauseAfterDelete);
      }
    };

    typeChar();
  }, []);

  useEffect(() => {
    typePhrase();
    return () => clearTimeout(timeoutRef.current);
  }, [typePhrase]);

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <img
        src="/images/shop/hero.jpg"
        alt="Shop"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
          display: 'block',
        }}
      />
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(transparent 30%, rgba(0,0,0,0.7) 100%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
        }}
      >
        <h1
          style={{
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 700,
            fontSize: 'clamp(32px, 6vw, 72px)',
            color: '#ffffff',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            margin: 0,
            textShadow: '0 2px 12px rgba(0,0,0,0.5)',
          }}
        >
          Pre Made Luts
        </h1>
        <p
          style={{
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 400,
            fontSize: 'clamp(14px, 2.5vw, 24px)',
            color: 'rgba(255,255,255,0.8)',
            letterSpacing: '0.06em',
            margin: 0,
            textShadow: '0 1px 8px rgba(0,0,0,0.4)',
            minHeight: '1.3em',
          }}
        >
          {display}
          <span
            style={{
              opacity: cursorVisible ? 1 : 0,
              fontWeight: 300,
              marginLeft: 2,
              transition: 'opacity 0.1s',
            }}
          >
            |
          </span>
        </p>
      </div>
    </div>
  );
};

export default ShopHero;
